//banner图片轮播
$(function () {
  const $imgs = $(".app-iot-header-banner-wrap .app-img-swiper-item");
  if ($imgs.length > 1) {
    const $pagination = $('<div class="pagination-wrap"></div>');
    for (let i = 0; i < $imgs.length; i++) {
      $pagination.append(
        '<div class="pagination-item"><i class="white-box"></i></div>'
      );
    }
    $(".app-iot-header-banner-wrap .app-img-swiper-list").after($pagination);
  }
  //
  const $paginations = $(
    ".app-iot-header-banner-wrap .pagination-wrap .pagination-item"
  );
  //
  let activeIndex = 0;
  const activeSync = () => {
    if (!$imgs.get(activeIndex)) {
      activeIndex = 0;
    }
    $imgs.removeClass("active").eq(activeIndex).addClass("active");
    $paginations.removeClass("active").eq(activeIndex).addClass("active");
  };
  setTimeout(activeSync, 100);
  $paginations.on("click", function () {
    activeIndex = $paginations.index($(this));
    activeSync();
    restartInterval();
  });
  let interval = null;
  const restartInterval = () => {
    clearInterval(interval);
    interval = setInterval(() => {
      activeIndex++;
      activeSync();
    }, 5000);
  };
  restartInterval();
});
